import type { StepRenderProps } from "./types";
import type { NumberStep as NumberStepConfig } from "@/types/offer";

export function NumberStep({ step, value, onChange, autoFocus, error }: StepRenderProps<NumberStepConfig>) {
  return (
    <input
      type="number"
      inputMode="numeric"
      className="r1-field"
      autoFocus={autoFocus}
      placeholder={step.placeholder}
      min={step.validation?.min}
      max={step.validation?.max}
      value={typeof value === "string" || typeof value === "number" ? String(value) : ""}
      onChange={(e) => onChange(e.target.value)}
      aria-invalid={!!error}
      aria-label={step.title}
    />
  );
}
